export default __webpack_public_path__ + "static/media/dots.9210214a.svg";